import type { RefObject } from 'react';
import type { Track, ViewerAnimState, ViewerNavigationMode } from '@mindcloudxai_3d/core';
import type { RendererController } from '@renderer/index';
import { useViewerStore } from '@stores/viewerStore';

// ===========================================================================
// viewer 事件与轨迹 — runtime 事件回流 store。
// ===========================================================================

/** viewer 事件 → store 桥接；返回清理函数。 */
export function bindViewerEvents(
  ctrl: RendererController,
  trackRef: RefObject<Track | null>,
): () => void {
  const onNavModeChange = (mode: ViewerNavigationMode) => {
    useViewerStore.getState().setNavigationMode(mode);
  };
  const onAnimChanged = (anim: ViewerAnimState) => {
    if (!trackRef.current) return;
    const s = useViewerStore.getState();
    s.setCinematicCurrentTime(anim.time);
    s.setCinematicState(deriveCinematicState(anim));
  };
  ctrl.on('navigationMode:changed', onNavModeChange);
  ctrl.on('anim:changed', onAnimChanged);
  return () => {
    ctrl.off('navigationMode:changed', onNavModeChange);
    ctrl.off('anim:changed', onAnimChanged);
  };
}

/** ViewerAnimState → CinematicState 映射，消除嵌套三元。 */
export function deriveCinematicState(anim: ViewerAnimState): 'idle' | 'playing' | 'paused' {
  if (!anim.hasAnimation) return 'idle';
  return anim.active && !anim.paused ? 'playing' : 'paused';
}
